import * as finance from './finance'
import * as date from './date'
import * as turkish from './turkish'
import * as social from './social'
import * as security from './security'
import * as dashboard from './dashboard'
import * as debts from './debts'
import { rateService } from '@/services/rateService'

// Re-export all individual functions/constants
export * from './types'
export * from './finance'
export * from './date'
export * from './turkish'
export * from './social'
export * from './security'
export * from './dashboard'
export * from './debts'

/**
 * Abacus namespace'i - Tüm hesaplama fonksiyonlarını tek noktadan erişim
 * Geriye dönük uyumluluk için korunmuştur.
 */
export const Abacus = {
  ...finance,
  ...date,
  ...turkish,
  ...social,
  ...security,
  ...dashboard,
  ...debts,

  // Rate Servis Proxy
  getRateByDate: (targetDate: string) => rateService.getRateByDate(targetDate),
  getTodayRates: () => rateService.getTodayRates(),

  /**
   * Premium UX Delay
   */
  premiumDelay: (ms: number = 600) => {
    if (dashboard.getCachedDashboardData()) return Promise.resolve()
    return new Promise(resolve => setTimeout(resolve, ms))
  },
} as const
